import axios from "axios";

const api = axios.create({
  withCredentials: true,
  // baseURL: "http://127.0.0.1:8000/",//local development
  // baseURL: "http://103.149.74.170:8075/",//office server
  baseURL: "https://aqc.techtrioz.xyz/",//production server
  // baseURL : "http://59.152.103.142:8004/",
  headers: { "Content-Type": "application/json" },
});

// ─── REQUEST INTERCEPTOR ──────────────────────────────────────────────────────
// Automatically attach Bearer token from localStorage on every request.
// This means no manual header setting needed anywhere in the app.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ─── RESPONSE INTERCEPTOR ─────────────────────────────────────────────────────
// On 401 (token expired), attempt one silent refresh.
// Backend sends 401 for expired/invalid tokens.
let isRefreshing = false;

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    // Guard: network error with no response
    if (!error.response) {
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    // Attempt token refresh only on 401, only once per request
    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const r_token = localStorage.getItem("r_token");

        if (!r_token) {
          _forceLogout();
          return Promise.reject(error);
        }

        const { status, data } = await api.post("/auth/refresh", {
          r_token: r_token,
        });

        if (status === 200 && data.token) {
          localStorage.setItem("jwt", data.token);
          api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
          originalRequest.headers["Authorization"] = `Bearer ${data.token}`;
          return api(originalRequest);
        } else {
          _forceLogout();
          return Promise.reject(error);
        }
      } catch (refreshError) {
        _forceLogout();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

// ─── FORCE LOGOUT ─────────────────────────────────────────────────────────────
// Called when refresh fails. Clears storage and redirects to login.
function _forceLogout() {
  localStorage.clear();
  if (window.location.pathname !== "/") {
    window.location.href = "/";
  }
}

export default api;